<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">标题：</div>
        <el-input v-model="filters.desc" placeholder="" size="mini" class="input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
      <router-link class="blue-small-btn ml-auto" :to="{path: '/sjEdit', query: {sid: 0}}">新建</router-link>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="sid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="desc" label="标题" width="" align="center">
      </el-table-column>
      <el-table-column prop="url" label="链接" width="400" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.url.length <= 45" @click="copyLink">
            <div slot="reference">{{scope.row.url}}</div>
          </div>
          <el-popover placement="top-end" trigger="hover" :content="scope.row.url" v-else>
            <div slot="reference"  @click="copyLink">{{scope.row.url.slice(0, 100) + '...'}}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="short_url" label="短链" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="状态" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0" class="red-small-btn" @click="changeSjInfo(scope.$index)">失效</div>
          <div v-if="scope.row.status == 1" class="blue-small-btn" @click="changeSjInfo(scope.$index)">正常</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <router-link class="blue-small-btn ml-10" :to="{path: '/sjEdit', query: {sid: scope.row.sid}}">编辑</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import Clipboard from 'clipboard'
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {sjLists, sjEdit} from '../../../api/api'
export default {
  name: 'sjList',
  mixins: [mixinList],
  data () {
    return {
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '失效',
          value: 0
        },
        {
          name: '正常',
          value: 1
        }
      ],
      lists: [],
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        desc: '',
        status: ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    changeSjInfo (index) {
      let sid = this.lists[index].sid
      let status = this.lists[index].status === 1 ? 0 : 1

      let params = {
        sid: sid,
        status: status
      }
      sjEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.desc !== '') {
        params.desc = filters.desc
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      this.listLoading = true
      sjLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    copyLink () {
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success'
        })

        // 释放内存
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        this.$notify({
          title: '失败',
          message: '复制失败',
          type: 'error'
        })

        // 释放内存
        clipboard.destroy()
      })
    },
    statusChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  watch: {
    'filters.status': 'statusChange'
  },
  mounted () {
    this.getList()
    util.setCookie('createAddetail', '')
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/sj/sjList.vue